import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';

var root = $.from_html(`<button><!></button>`);

const $$css = {
	hash: 'svelte-1s4oaxf',
	code: '.button.svelte-1s4oaxf {border:1px solid var(--color-line);background:var(--color-panel);border-radius:8px;padding:6px 11px;font-size:12px;color:var(--color-text);cursor:pointer;transition:120ms ease;}.button.svelte-1s4oaxf:hover {border-color:var(--color-accent);transform:translateY(-1px);}.button.svelte-1s4oaxf:disabled,\n  .button.svelte-1s4oaxf:disabled:hover {opacity:0.45;cursor:not-allowed;border-color:var(--color-line);transform:none;}.button-secondary.svelte-1s4oaxf {color:var(--color-muted);}.button-submit.svelte-1s4oaxf {border-color:var(--color-accent);background:var(--color-accent);color:var(--color-accent-ink);font-weight:700;}.button-destructive.svelte-1s4oaxf {background:transparent;color:var(--color-danger-text);}.button-small.svelte-1s4oaxf {font-size:10px;padding:3px 7px;}.button-menu-trigger.svelte-1s4oaxf {display:flex;align-items:center;justify-content:center;min-height:30px;padding:4px 8px;font-size:16px;line-height:1;color:var(--color-text-strong);}.button-menu-trigger[aria-expanded="true"].svelte-1s4oaxf {border-color:var(--color-accent);background:color-mix(in srgb, var(--color-panel), var(--color-accent) 12%);}.button-menu-item.svelte-1s4oaxf {width:100%;display:flex;align-items:center;justify-content:flex-start;border:none;border-radius:8px;background:transparent;padding:8px 10px;font-size:12px;color:var(--color-text);}.button-menu-item.svelte-1s4oaxf:hover,\n  .button-menu-item.svelte-1s4oaxf:active {transform:none;}.button-menu-item.svelte-1s4oaxf:hover {background:color-mix(\n      in srgb,\n      var(--color-panel-2),\n      var(--color-accent) 16%\n    );}.button-menu-item.svelte-1s4oaxf:active {background:color-mix(\n      in srgb,\n      var(--color-panel-2),\n      var(--color-accent) 24%\n    );}.button-menu-item.svelte-1s4oaxf:focus-visible {outline:1px solid var(--color-accent);outline-offset:1px;}.button-active.svelte-1s4oaxf {border-color:var(--color-accent);background:var(--color-accent);color:var(--color-accent-ink);font-weight:700;}'
};

export default function Svelte_button($$anchor, $$props) {
	$.push($$props, true);
	$.append_styles($$anchor, $$css);

	let type = $.prop($$props, 'type', 7, "button"),
		variant = $.prop($$props, 'variant', 7, "default"),
		active = $.prop($$props, 'active', 7, false),
		disabled = $.prop($$props, 'disabled', 7, false),
		className = $.prop($$props, 'className', 7, ""),
		id = $.prop($$props, 'id', 7, undefined),
		element = $.prop($$props, 'element', 15, null),
		role = $.prop($$props, 'role', 7, undefined),
		ariaLabel = $.prop($$props, 'ariaLabel', 7, undefined),
		ariaPressed = $.prop($$props, 'ariaPressed', 7, undefined),
		ariaHaspopup = $.prop($$props, 'ariaHaspopup', 7, undefined),
		ariaExpanded = $.prop($$props, 'ariaExpanded', 7, undefined),
		handlePress = $.prop($$props, 'handlePress', 7, undefined),
		handleKeyPress = $.prop($$props, 'handleKeyPress', 7, undefined),
		handleMouseDown = $.prop($$props, 'handleMouseDown', 7, undefined),
		blurOnPress = $.prop($$props, 'blurOnPress', 7, false),
		children = $.prop($$props, 'children', 7);

	const variantClass = (v) => v === "default" ? "button" : `button-${v}`;

	const classes = $.derived(() => [
		"button",
		(Array.isArray(variant()) ? variant() : [variant()]).map(variantClass).join(" "),
		active() ? "button-active" : "",
		className()
	].filter(Boolean).join(" "));

	var $$exports = {
		get type() {
			return type();
		},

		set type($$value = "button") {
			type($$value);
			$.flush();
		},

		get variant() {
			return variant();
		},

		set variant($$value = "default") {
			variant($$value);
			$.flush();
		},

		get active() {
			return active();
		},

		set active($$value = false) {
			active($$value);
			$.flush();
		},

		get disabled() {
			return disabled();
		},

		set disabled($$value = false) {
			disabled($$value);
			$.flush();
		},

		get className() {
			return className();
		},

		set className($$value = "") {
			className($$value);
			$.flush();
		},

		get id() {
			return id();
		},

		set id($$value = undefined) {
			id($$value);
			$.flush();
		},

		get element() {
			return element();
		},

		set element($$value = null) {
			element($$value);
			$.flush();
		},

		get role() {
			return role();
		},

		set role($$value = undefined) {
			role($$value);
			$.flush();
		},

		get ariaLabel() {
			return ariaLabel();
		},

		set ariaLabel($$value = undefined) {
			ariaLabel($$value);
			$.flush();
		},

		get ariaPressed() {
			return ariaPressed();
		},

		set ariaPressed($$value = undefined) {
			ariaPressed($$value);
			$.flush();
		},

		get ariaHaspopup() {
			return ariaHaspopup();
		},

		set ariaHaspopup($$value = undefined) {
			ariaHaspopup($$value);
			$.flush();
		},

		get ariaExpanded() {
			return ariaExpanded();
		},

		set ariaExpanded($$value = undefined) {
			ariaExpanded($$value);
			$.flush();
		},

		get handlePress() {
			return handlePress();
		},

		set handlePress($$value = undefined) {
			handlePress($$value);
			$.flush();
		},

		get handleKeyPress() {
			return handleKeyPress();
		},

		set handleKeyPress($$value = undefined) {
			handleKeyPress($$value);
			$.flush();
		},

		get handleMouseDown() {
			return handleMouseDown();
		},

		set handleMouseDown($$value = undefined) {
			handleMouseDown($$value);
			$.flush();
		},

		get blurOnPress() {
			return blurOnPress();
		},

		set blurOnPress($$value = false) {
			blurOnPress($$value);
			$.flush();
		},

		get children() {
			return children();
		},

		set children($$value) {
			children($$value);
			$.flush();
		}
	};

	var button = root();
	var node = $.child(button);

	$.snippet(node, () => children() ?? $.noop);
	$.reset(button);
	$.bind_this(button, ($$value) => element($$value), () => element());

	$.template_effect(() => {
		$.set_attribute(button, 'type', type());
		$.set_attribute(button, 'id', id());
		$.set_attribute(button, 'role', role());
		$.set_class(button, 1, $.clsx($.get(classes)), 'svelte-1s4oaxf');
		button.disabled = disabled();
		$.set_attribute(button, 'aria-label', ariaLabel());
		$.set_attribute(button, 'aria-pressed', ariaPressed());
		$.set_attribute(button, 'aria-haspopup', ariaHaspopup());
		$.set_attribute(button, 'aria-expanded', ariaExpanded());
	});

	$.delegated('mousedown', button, (event) => handleMouseDown()?.(event));

	$.delegated('click', button, (event) => {
		if (blurOnPress() && event.currentTarget instanceof HTMLButtonElement) {
			event.currentTarget.blur();
		}

		handlePress()?.();
	});

	$.delegated('keydown', button, (event) => handleKeyPress()?.(event));
	$.append($$anchor, button);

	return $.pop($$exports);
}

$.delegate(['mousedown', 'click', 'keydown']);

$.create_custom_element(
	Svelte_button,
	{
		type: {},
		variant: {},
		active: {},
		disabled: {},
		className: {},
		id: {},
		element: {},
		role: {},
		ariaLabel: {},
		ariaPressed: {},
		ariaHaspopup: {},
		ariaExpanded: {},
		handlePress: {},
		handleKeyPress: {},
		handleMouseDown: {},
		blurOnPress: {},
		children: {}
	},
	[],
	[],
	{ mode: 'open' }
);